import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "text-align": "center",
    "margin-top": "10%"
  }
};
const _hoisted_2 = {
  ref: "spanEl",
  style: {
    "color": "#00aeff"
  }
};
const _hoisted_3 = {
  style: {
    "color": "#F6416C"
  }
};
import useStore from '@/store';
import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Home'
  },
  __name: 'Home',
  setup(__props) {
    const store = useStore();
    const profile = computed(() => store.user.profile);
    return (_ctx, _cache) => {
      const _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(() => [_createElementVNode("h1", _hoisted_1, [_createElementVNode("span", _hoisted_2, "您好！", 512), _cache[0] || (_cache[0] = _createTextVNode()), _createElementVNode("span", _hoisted_3, _toDisplayString(profile.value?.nickname), 1)])]),
        _: 1
      });
    };
  }
});